import React from 'react'
import kebabcase from 'lodash.kebabcase'

import PageHeader from './PageHeader'
import NavBar from './NavBar'
import ConsentListSectionHeader from './ConsentListSectionHeader'
import AccessTppCard, { EmptyAccessTppCard } from './AccessTppCard'

import style from './AccessTPPs.module.css'

export default function AccessTPPs({
  accesses,
  handleDisaplyChangesTo90DayDetails,
}) {
  return (
    <section className="js-tpp-list">
      <PageHeader
        navbar={<NavBar />}
        title="Account information"
        subtitle="A list of service providers you have given access to your account information."
        handleLink={handleDisaplyChangesTo90DayDetails}
      />
      <div className={style.sections}>
        <AccessTppSection
          label="Connected"
          description="Apps and websites who you are sharing account information with."
          tpps={accesses.get('activeTpps')}
        />

        <AccessTppSection
          label="Disconnected"
          description="History of apps and websites who you had shared your account information with."
          tpps={accesses.get('inactiveTpps')}
        />
      </div>
    </section>
  )
}

function AccessTppSection({ label, description, tpps }) {
  return (
    <section
      className={`${style.section} js-${kebabcase(label)}-access-tpp-section`}
    >
      <ConsentListSectionHeader
        count={tpps.size}
        label={label}
        description={description}
        consentType="access"
      />
      {tpps.size > 0 ? (
        tpps
          .valueSeq()
          .map((tpp, index) => (
            <AccessTppCard key={tpp.get('clientId')} tpp={tpp} index={index} />
          ))
          .toArray()
      ) : (
        <EmptyAccessTppCard />
      )}
    </section>
  )
}
